export default "__VITE_ASSET__CGc_hqWp__"